import { ScoredCreditCardProduct } from '@ilg-totallymoney/types'

import { CreditCardProductCategory } from '@appTypes/EligibilityApi.interface'

import { getCardHasOfferDuration } from '@utils/getCardHasOfferDuration'

interface Options {
    card: ScoredCreditCardProduct | null
    category: CreditCardProductCategory
}

const offerDurationCategories = [
    'BestCards',
    'Purchase',
    'BalanceTransfer',
    'Combined',
]

export function getShowOfferDurationContent({ category, card }: Options) {
    const hasOfferDurationCategory = offerDurationCategories.includes(category)
    return hasOfferDurationCategory && getCardHasOfferDuration(card)
}
